import { render, staticRenderFns } from "./KnownMeasureDetailPage.vue?vue&type=template&id=228a2f24&"
import script from "./KnownMeasureDetailPage.vue?vue&type=script&lang=js&"
export * from "./KnownMeasureDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports